import React, { PureComponent } from 'react';

class Footer extends PureComponent {
  render() {
    return (
      <>
        <div id="about-this-project" class="mx-auto py-12 px-6 max-w-4xl text-white font-sans antialiased">
          <h2 class="text-2xl font-bold">使用した技術</h2>
          <h3 class="font-bold mt-4"><a href="https://ja.reactjs.org/" target="_blank" noreferrer noopener>React</a></h3>
          <ul class="list-disc">
            <li class="ml-6">インタラクティブなUIを制作するためのJavaScriptライブラリ。</li>
          </ul>

          <h3 class="font-bold mt-4"><a href="https://react-leaflet.js.org/" target="_blank" noreferrer noopener>React Leaflet</a></h3>
          <ul class="list-disc">
            <li class="ml-6">OpenStreetMapの地図を扱うためのJavascriptライブラリ。</li>
          </ul>

          <h3 class="font-bold mt-4"><a href="https://github.com/jsonkao/react-scrollama" target="_blank" noreferrer noopener>React Scrollama</a></h3>
          <ul class="list-disc">
            <li class="ml-6">"スクローリーテリング"を実装するためのライブラリ。</li>
            <li class="ml-6">地図部分の固定、画面右側のスライダーなどに利用。</li>
          </ul>

          <h2 class="text-2xl font-bold mt-16">データソース</h2>
          <h3 class="font-bold mt-4"><a href="http://codh.rois.ac.jp/bukan/book/200018823/map/" target="_blank" noreferrer noopener>武鑑全集</a></h3>
          <ul class="list-disc">
            <li class="ml-6">「武鑑全集」（CODH制作） 「日本古典籍データセット」（国文研所蔵）を翻案。</li>
            <li class="ml-6">「寛政年間 諸大名の勢力図」および「関ヶ原の前後比較」の一部（居城の地理情報）に利用。</li>
            <li class="ml-6">提供 : <a href="http://codh.rois.ac.jp/" target="_blank" noreferrer noopener>人文学オープンデータ共同利用センター</a></li>
          </ul>
          <a href="https://creativecommons.org/licenses/by-sa/4.0/"><img class="mt-3 mb-6" src="https://licensebuttons.net/l/by-sa/4.0/88x31.png" /></a>

          <h3 class="font-bold mt-4"><a href="http://www.m-network.com/sengoku/sekigahara/data_5over.html" target="_blank" noreferrer noopener>関ヶ原前後における大名領地表１(五万石以上の大名／旧石高順)</a></h3>
          <ul class="list-disc">
            <li class="ml-6">「関ヶ原の前後比較」にて、石高と旧領地・新封地の情報を利用。</li>
          </ul>

          <h3 class="font-bold mt-4">Wikipedia (GeoHack)</h3>
          <ul class="list-disc">
            <li class="ml-6">上記データソースには、居城の地理情報は含まれていない。そこで「武鑑全集」に記載のある城に関してはそちらの地理情報を利用し、記載のない城はWikipediaのページ（例 : <a href="https://ja.wikipedia.org/wiki/%E6%B1%9F%E6%88%B8%E5%9F%8E" target="_blank" noreferrer noopener>江戸城</a>）にある地理情報を利用した。</li>
          </ul>

          <h2 class="text-2xl font-bold mt-16">データセット</h2>
          <h3 class="font-bold mt-4"><a href="https://docs.google.com/spreadsheets/d/1vfw1kFyO4vAZE3w-g3pmUhKbs-XBQ0hd5bl0BMQ0c_k/edit?usp=sharing" target="_blank" noreferrer noopener>関ヶ原前後の石高推移</a></h3>
          <p>上記のデータソースから作成したデータセットを公開しています。</p>

          <h2 class="text-2xl font-bold mt-16">考慮したこと</h2>
          <h3 class="font-bold mt-4">視覚変数の選定</h3>
          <ul class="list-disc">
            <li class="ml-6">現代と違って、江戸時代の各地の情勢を定量的に知ることができる指標はかなり少ない。</li>
            <li class="ml-6">戦国時代は大名どうしが領地争いを繰り広げたのに対し、江戸時代には大名の実力は領地面積ではなく<strong>石高</strong>で測られるようになったと考えられる。</li>
            <li class="ml-6">江戸時代に庶民の間で流行した「見立番付」でも、上位にランクインしている大名ほど石高が高い。</li>
            <li class="ml-6">石高は米の生産量を基準として算出されるため、領内の耕地面積とは比例すると考えられるが、山林などを含めた<strong>領地面積</strong>とは必ずしも比例しない。</li>
            <li class="ml-6">そこで、領域を色で塗り分ける方法（コロプレス地図）は不適切と考え、<a href="https://www.data-to-viz.com/graph/bubblemap.html" target="_blank" noreferrer noopener><strong>バブルマップ</strong></a>を採用した。</li>
          </ul>

          <h3 class="font-bold mt-4">スクロールと地図上の要素との連係</h3>
          <ul class="list-disc">
            <li class="ml-6">React Leafletでは、CircleをMarkerのように動かしたり削除したりできない模様。setLatLngメソッド、moveメソッド、redrawメソッドが効かない。そこであらかじめCircleをすべて描いておいて、opacityの切り替えで対処。</li>
          </ul>

          <h3 class="font-bold mt-4">構成の検討</h3>
          <ul class="list-disc">
            <li class="ml-6">視点の移動・地図の拡大縮小をなるべく少なく抑えられるように、紹介する大名の順序を設定した。</li>
            <li class="ml-6">第1編にて寛政年間の勢力図を題材にして共時的な比較を行なった上で、第2編で関ヶ原の戦後処理を紹介し、通時的な比較を加えた。当初は時系列に沿うように、第1編と第2編の順序を逆にしようと考えたが、コンテンツが長くなり過ぎると考え、順序を入れ替えた。</li>
          </ul>
        </div>
      </>
    )
  }
}

export default Footer